module.exports = __webpack_public_path__ + "img/2.1457eb8f.png";